
















































































import {FormInput, Select,} from '@/pages/profile/blocks';
import {Checkbox} from '@/components/form';
import {Button} from '@/pages/profile/components';
import {validationMixin} from 'vuelidate';
import {IStudyPlace} from '../types';
import {minLength, numeric, required} from 'vuelidate/lib/validators';

export default {
  name: 'AddEditStudyPlaceBody',
  mixins: [validationMixin],
  components: {
    FormInput,
    Checkbox,
    Select,
    Button
  },
  props: {
    studyPlace: {
      type: Object,
      default: (): IStudyPlace => ({
        study_place: '',
        year: undefined,
        is_currently: true,
        education_type: 'BASIC',
        education_level: null,
        specialization: '',
        course_name: '',
      })
    },
    educationTypeDict: {
      type: Array
    },
    educationLevelDict: {
      type: Array
    },
    saveMethod: {
      type: Function
    },
    study: {
      type: Array
    },
  },
  data(self: any) {
    return {
      excludeForAdditional: ['ADDITIONAL'],
      excludeForBasic: ['BASIC'],
      studyPlaceData: this.studyPlace,
      errors: [],
    }
  },
  computed: {
    studyPlaceComputed: {
      get() {
        return this.studyPlaceData;
      },
      set(value: IStudyPlace) {
        this.studyPlaceData = value;
      }
    }
  },
  validations: {
    studyPlaceComputed: {
      study_place: {
        required,
      },
      education_type: {
        required,
      },
      education_level: {
        required: async (value: string, context: any) => {
          // console.log(value, context);
          return (await context.education_type === 'ADDITIONAL') ? true : required(value);
        },
      },
      is_currently: {},
      year: {
        required: async (value: string, context: any) => {
          return (await context.is_currently) ? true : required(value)
        },
        numeric,
        minLength: minLength(4),
        lessThen: async (value: any, context: any) => {
          return (await context.is_currently) ? true : value >= 1900
        },
        moreThen: async (value: any, context: any) => {
          return (await context.is_currently) ? true :value <= Number(new Date().getFullYear())
        },
      },
    }
  },
  watch: {
    ['studyPlaceComputed.education_type'](newValue: string) {
      if (this.excludeForAdditional.includes(newValue)) {
        this.$set(this.studyPlaceComputed, 'education_level', null);
        this.$v.studyPlaceComputed.education_level.$reset();
      }
      if (this.excludeForBasic.includes(newValue)) {
        this.$set(this.studyPlaceComputed, 'course_name', '');
      }
    },
    ['studyPlaceComputed.is_currently'](newValue: boolean) {
      if (!newValue) {
        this.$v.studyPlaceComputed.year.$reset();
      }
    }
  },

  methods: {
    resetYear() {
      if (this.studyPlaceComputed.is_currently && this.$v.studyPlaceComputed.year.$dirty) {
        this.$v.studyPlaceComputed.year.$reset();
        this.$set(this.studyPlaceComputed, 'year', undefined);
      }
    },
    validate() {
      this.$v.studyPlaceComputed.$touch()
      return this.$v.studyPlaceComputed.$invalid;
    },
    getError(vuelidateObject: any, additionalData: any | undefined): string {
      const keys = Object.keys(vuelidateObject);
      const errorField: string | undefined = keys
      .filter(el => !/^\$/.test(el))
      .find(el => !vuelidateObject[el]);
      const validationFieldMap = new Map([
        ['required', 'Поле обязательно к заполнению'],
        ['numeric', 'Неверный формат'],
        ['minLength', 'Неверный формат'],
        ['lessThen', `${additionalData?.field} должен быть ${additionalData?.additional}`],
        ['moreThen', `${additionalData?.field} должен быть ${additionalData?.additional}`],
        [undefined, 'Неверный формат'],
      ])
      return validationFieldMap.get(errorField) as string;
    },
    collectData() {
      const data = {
        ...this.studyPlaceComputed
      }
      // TODO: update with conditions
      return data;
    },
    close() {
      this.$ui.$modal.close('AddEditStudyPlace');
    },
    save() {
      const isValid = this.validate();
      this.errors.splice(0, this.errors.length);
      if (!isValid) {
        const preparedData = this.collectData();
        Object.keys(preparedData).forEach(index => {
          if (!preparedData[index]) delete preparedData[index];
        });
        this.saveMethod([preparedData])
          .then(() => {
            this.close();
          })
          .catch((err: Array<any>) => {
            const errorList = err.map(el => el.msg);
            this.errors.push(...errorList);
          });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/study/components/AddEditStudyPlaceBody.vue